import { hasListener } from '@client/selectors/helpers/listeners';
import { unsubscribeShowProducts, startFetchShowProducts } from '@client/slices/entities/products.reducer';
import { removeFirestoreListener, addFirestoreListener } from '@client/slices/helpers/listeners.reducer';
import type { AddListener } from '@client/listeners/lib';

export const withShowProductsListeners = (addListener: AddListener) => [
  addListener({
    actionCreator: unsubscribeShowProducts,
    effect: (action, listenerApi) => {
      const showId = action.payload;
      const { dispatch } = listenerApi;

      const productListener = `list-show-products-${showId}`;
      dispatch(removeFirestoreListener(productListener));
    },
  }),

  addListener({
    actionCreator: startFetchShowProducts,
    effect: (action, listenerApi) => {
      const showId = action.payload;

      const state = listenerApi.getState();
      const { dispatch } = listenerApi;

      const listener = hasListener(state, `list-show-products-${showId}`);

      if (!listener) {
        const firebase = window.Firebase;

        const watchListener = firebase.SDK.Products.watch({
          queries: (query) => [
            query.isEqualTo('showId', showId),
          ],
        });

        dispatch(addFirestoreListener({ watchListener, name: `list-show-products-${showId}` }));
      }
    },
  }),
];
